module.exports = __webpack_public_path__ + "img/vehicle-911.d55b970c.jpg";